/* ============================================================
   GENERATE V2 (Workspace sebenar) — Goal · Format · Pill setiap module
   ============================================================
   Keputusan user 23 Okt 2026:
   • Tab galeri = matlamat pelanggan: Sell (affiliate TikTok + Shopee) ·
     Grow (ternak / warm up akaun) · Earn (monetize YouTube + FB Pro).
   • Admin menetapkan Goal / Format / Pill dalam modal tetapan module
     (pensel kad) — medan `kadGoal` · `kadFormat` · `kadPil` pada doc
     `modules/{id}`.
   • Nilai LALAI di bawah ditulis oleh user ("AI8SAAT · AI16SAAT · GOYANG =
     HOLD, master prompt sekarang memang model pegang produk; HOME NICHE =
     DEMO; FLOWNITY + SMART = Sell tanpa pill"). Lalai hidup dalam KOD,
     bukan ditulis ke Firestore — tiada tulisan data production.

   ⛔ Corak SAMA seperti `kadBadge`/`kadDurasi`: `undefined` = admin belum
      pernah simpan → guna lalai; `''` = admin sengaja kosongkan (cth Pill
      tiada, Goal tiada → module hanya dalam tab All). Jangan tukar
      `undefined` kepada `''` di pemuat modules.
   ============================================================ */

export const GOAL_V2 = [
    { id: 'sell', nama: 'Sell', nota: 'TikTok + Shopee affiliate' },
    { id: 'grow', nama: 'Grow', nota: 'Warm up TikTok / FB page' },
    { id: 'earn', nama: 'Earn', nota: 'Monetize YouTube + FB Pro' },
];
export const FORMAT_V2 = [
    { id: 'video', nama: 'Video' },
    { id: 'image', nama: 'Image' },
    { id: 'text', nama: 'Text' },
];
export const PIL_V2 = ['HOLD', 'DEMO', 'ZOOM'];

const LALAI = {
    ai8saat: { goal: 'sell', format: 'video', pil: 'HOLD' },
    ai16saat: { goal: 'sell', format: 'video', pil: 'HOLD' },
    /* AI16SAAT dikenali dengan DUA id (nota FORMULA_MEDIA dalam App.jsx). */
    'ai16saat-half': { goal: 'sell', format: 'video', pil: 'HOLD' },
    goyang: { goal: 'sell', format: 'video', pil: 'HOLD' },
    homeniche: { goal: 'sell', format: 'video', pil: 'DEMO' },
    flownity: { goal: 'sell', format: 'video', pil: '' },
    smartcustom: { goal: 'sell', format: 'video', pil: '' },
};

const sah = (nilai, senarai) => senarai.includes(nilai);

/** Goal / Format / Pill berkesan untuk satu module (doc `modules/{id}` + lalai kod).
    Nilai tidak dikenali → diabaikan (Goal kosong, Format video, Pill tiada). */
export function matlamatModule(mod) {
    const id = mod?.id;
    const lalai = LALAI[id] || { goal: '', format: 'video', pil: '' };
    const goal = mod?.kadGoal !== undefined ? mod.kadGoal : lalai.goal;
    const format = mod?.kadFormat !== undefined ? mod.kadFormat : lalai.format;
    const pil = mod?.kadPil !== undefined ? mod.kadPil : lalai.pil;
    return {
        goal: sah(goal, GOAL_V2.map((g) => g.id)) ? goal : '',
        format: sah(format, FORMAT_V2.map((f) => f.id)) ? format : 'video',
        pil: sah(pil, PIL_V2) ? pil : '',
    };
}

/* ── Scene yang pelanggan boleh pilih (keputusan user 24 Okt) ──────────────
   Admin menanda 1–5 dalam modal tetapan module (medan `kadScenes`, senarai nombor).
   Lalai (`undefined`) = bilangan scene sedia ada module itu (`getSceneCount`) —
   AI8SAAT [1], AI16SAAT/HOME NICHE [2]; SMART [1, 2] (pelanggan memang memilih 1 atau
   2 babak hari ini). ⚠️ Kini RUPA SAHAJA: Generate + robot masih memakai bilangan
   scene module, bukan pilihan ini (belum bersambung — arahan user). */
export const MAKS_SCENE_V2 = 5;

export function sceneModule(mod, lalai) {
    const asal = Math.max(1, Math.min(MAKS_SCENE_V2, Math.floor(Number(lalai)) || 1));
    const sumber = Array.isArray(mod?.kadScenes) ? mod.kadScenes : (mod?.id === 'smartcustom' ? [1, 2] : [asal]);
    const bersih = [...new Set(sumber.map(Number).filter((n) => Number.isInteger(n) && n >= 1 && n <= MAKS_SCENE_V2))].sort((a, b) => a - b);
    return bersih.length ? bersih : [asal];
}

/** Keputusan user 24 Okt: 1–2 scene = 3 set setiap card · 3–5 scene = 1 set. */
export function bilSetUntukScene(n) {
    return Number(n) >= 3 ? 1 : 3;
}

/** Kad yang dipapar untuk tab ('' = All) + tapisan format ('' = semua). */
export function tapisGoal(kad, goalId, formatId) {
    return (Array.isArray(kad) ? kad : [])
        .filter((k) => (!goalId || k.goal === goalId) && (!formatId || k.format === formatId));
}
